import { GroupNodeData } from "@store/services/converter/types"
import { Node } from "reactflow"
import { GraphNodeChange } from "./graphApplyChanges"
import { NodePositionChange } from "reactflow"
import { GraphDataViewModel } from "@features/graph/graphViewModel"

export const groupNodeDragChanges = (
  change: NodePositionChange,
  nodeInternals: Map<string, Node>,
): GraphNodeChange[] => {
  const node = nodeInternals.get(change.id)
  if (!node) throw new Error(`groupNodeDragChanges Node ${change.id} not found`)
  const data: GroupNodeData = node.data

  const allIds = [change.id]
  if (!data.group.isCollapsed) {
    allIds.push(...data.group.nodes)
    if (GraphDataViewModel.data && GraphDataViewModel.data.childrenGroupMap[data.id]) {
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      allIds.push(...GraphDataViewModel.data.childrenGroupMap[data.id])
    }
  }

  const diffX = (change.position?.x || 0) - node.position.x
  const diffY = (change.position?.y || 0) - node.position.y

  const changes: GraphNodeChange[] = []
  for (const id of allIds) {
    const n = nodeInternals.get(id)
    if (!n) throw new Error(`groupNodeDragChanges Node ${id} not found`)
    const position = { x: n.position.x + diffX, y: n.position.y + diffY }
    changes.push({ id, selected: true, position })
  }
  return changes
}
